var render = function render(){
  var _vm$lVdocument;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-center"
  }, [_vm._v(" " + _vm._s(_vm.label) + " "), _c('div', [_c('img', {
    staticClass: "activate-button nav-link-icon filter-primary",
    "class": {
      'rotate': _vm.opened
    },
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg",
      "alt": ""
    },
    on: {
      "click": function click($event) {
        _vm.opened = !_vm.opened;
      }
    }
  })])]), _c('v-expand-transition', {
    staticClass: "summary-items-transition"
  }, [_vm.opened ? _c('div', {
    staticClass: "summary-items-wrapper"
  }, [_c('text-value-holder', {
    attrs: {
      "label": 'druh nehnuteľnosti',
      "value": _vm.convertType(_vm.getPropertySubType())
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'hodnota',
      "value": _vm.summaryData.hodnota
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'obec',
      "value": _vm.summaryData.address_text_city
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'ulica',
      "value": _vm.summaryData.address_text_street
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'súpisné číslo',
      "value": _vm.summaryData.address_text_popisne
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'orientačné číslo',
      "value": _vm.summaryData.address_text_number
    }
  }), _vm.summaryData.cislo_priestoru ? _c('text-value-holder', {
    attrs: {
      "label": 'číslo bytu / priestoru',
      "value": _vm.summaryData.cislo_priestoru
    }
  }) : _vm._e(), _c('text-value-holder', {
    attrs: {
      "label": 'PSČ',
      "value": _vm.summaryData.address_text_zip
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'katastrálne územie',
      "value": _vm.summaryData.katastralne_uzemie
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'list vlastníctva',
      "value": _vm.summaryData.cislo_lv
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'parcela',
      "value": _vm.summaryData.cislo_parcely
    }
  }), _vm.summaryData.podlahova_plocha ? _c('text-value-holder', {
    attrs: {
      "label": 'podlahová plocha',
      "value": "".concat(_vm.summaryData.podlahova_plocha, " m\xB2")
    }
  }) : _vm._e(), _c('text-value-holder', {
    attrs: {
      "label": 'počet izieb',
      "value": _vm.summaryData.pocet_izieb
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'rok kolaudácie',
      "value": _vm.summaryData.rok_kolaudacie
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'vlastník',
      "value": _vm.getPropertyOwner()
    }
  }), _vm._l((_vm$lVdocument = _vm.lVdocument) === null || _vm$lVdocument === void 0 ? void 0 : _vm$lVdocument.uploaded, function (file, index) {
    var _vm$lVdocument2;
    return Array.isArray((_vm$lVdocument2 = _vm.lVdocument) === null || _vm$lVdocument2 === void 0 ? void 0 : _vm$lVdocument2.uploaded) ? _c('file-download-holder', {
      key: index,
      attrs: {
        "cloud-file": file,
        "label": file.name
      }
    }) : _vm._e();
  })], 2) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }